export const BASE = "tips-picks";
export const CONTAINER = "container";
export const DESCRIPTION = "description";
export const TEXT = "text";
export const THUMBNAIL = "thumbnail";
export const ICON = "icon";
export const VIDEO = "video";
export const MODAL = "modal";
